export default {
      id: "oc-workwx-usage",
      viewBox: "0 0 1223 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-workwx",
      toString: function () {
        return this.url;
      }
    }